
const WRX = document.getElementById('wrx');
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } }), { threshold: .18 });
WRX.querySelectorAll('.wrx-reveal,.bar-anim').forEach(el => io.observe(el));

// scroll-scrubbed scenes
const scenes = [...WRX.querySelectorAll('[data-scene]')];
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
function drive(){
  const vh = innerHeight;
  scenes.forEach(sc => {
    const r = sc.getBoundingClientRect();
    let p = (vh * 0.52 - r.top) / (vh * 0.58);
    p = Math.max(0, Math.min(1, p));
    if (reduced) p = 1;
    sc.querySelector('.p-drive').style.setProperty('--p', p.toFixed(3));
    sc.classList.toggle('active', p > .12 && p < 1.35 && !reduced);
  });
}
addEventListener('scroll', () => requestAnimationFrame(drive), {passive:true});
addEventListener('resize', drive);
drive();

// ===== interactive WeRoll library demo (tool preselected) =====
const AREAS = ["Foot","Calf & Ankle","Shin","Hamstring","Inner Thigh","Middle Thigh","Outer Thigh","Hip","Hip Flexor & Psoas","Glute","Upper Back","Lat & Rotator Cuff","Chest & Shoulder"];
const demo = document.getElementById('libdemo');
if (demo) {
  let area = null;
  const show = n => {
    demo.querySelectorAll('.demo-screen').forEach(s => s.hidden = s.dataset.screen != n);
    demo.querySelectorAll('.dstep').forEach(d => d.classList.toggle('on', +d.dataset.dstep <= n));
  };
  const wrap = document.getElementById('areas');
  AREAS.forEach(a => {
    const el = document.createElement('button');
    el.className = 'areabtn'; el.textContent = a;
    el.addEventListener('click', () => { area = a; show(2); });
    wrap.appendChild(el);
  });
  demo.querySelectorAll('.lvlbtn').forEach(b => b.addEventListener('click', () => {
    document.getElementById('vidtitle').textContent = b.dataset.lvl + ' ' + area + ' Roll With Your WeRoll';
    show(3);
  }));
  demo.querySelectorAll('.demo-back').forEach(b => b.addEventListener('click', () => show(b.dataset.back)));
}

// ===== hero gallery =====
const sl = document.getElementById('hslider');
if (sl) {
  const slides = [...sl.children];
  const dots = document.getElementById('hdots');
  slides.forEach((_, i) => {
    const d = document.createElement('button');
    d.className = 'hdot' + (i === 0 ? ' on' : '');
    d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    d.addEventListener('click', () => sl.scrollTo({left: i * sl.clientWidth, behavior: 'smooth'}));
    dots.appendChild(d);
  });
  const upd = () => {
    const i = Math.round(sl.scrollLeft / sl.clientWidth);
    dots.querySelectorAll('.hdot').forEach((d, j) => d.classList.toggle('on', j === i));
  };
  sl.addEventListener('scroll', () => requestAnimationFrame(upd), {passive: true});
  WRX.querySelector('.hprev').addEventListener('click', () => sl.scrollBy({left: -sl.clientWidth, behavior: 'smooth'}));
  WRX.querySelector('.hnext').addEventListener('click', () => sl.scrollBy({left: sl.clientWidth, behavior: 'smooth'}));
}
